import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Container } from '@mui/material';
import LoginPage from './pages/LoginPage';
import AuthCallback from './pages/auth/AuthCallback';
import SilentRenew from './pages/auth/SilentRenew';
import PrivateRoute from './routes/PrivateRoute';
import AppLauncherPage from './pages/AppLauncherPage';

const App: React.FC = () => {
  return (
    <Container disableGutters maxWidth={false} sx={{ minHeight: '100vh', p: 0 }}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/auth/silent-renew" element={<SilentRenew />} />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <AppLauncherPage />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Container>
  );
};

export default App;

